import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * Davomat analitik layoutlarining (F1/F2) umumiy yordamchilari.
 *
 * ⚠️ KPI qatori va son formati BU YERDA EMAS — umumiy `KpiRow` va
 * `sonMatni` (`components/detail/KpiRow`) ishlatiladi: delta ma'nosi
 * (nisbiy %, foizda p.p.) barcha hisobotlarda bir xil bo'lishi shart.
 */

/** Bo'sh qiymat belgisi — `ReportTable` va `summaryDerive` dagi bilan bir xil. */
const BOSH = "—";

/** Minus belgisi — defis emas, raqam bilan bir kenglikda. */
const MINUS = "−";

/**
 * Daqiqa → `H:MM` (soat cheklanmaydi: `12345` → `205:45`).
 * Kasr daqiqa yumaloqlanadi.
 */
export function soatDaqiqa(daqiqa: number): string {
	const butun = Math.round(Math.abs(daqiqa));
	const belgi = daqiqa < 0 && butun > 0 ? MINUS : "";
	return `${belgi}${Math.floor(butun / 60)}:${String(butun % 60).padStart(2, "0")}`;
}

/**
 * ⚠️⚠️ **API foizi 0..100** (`rate()`, `@skud/domain`) — `summaryDerive`
 * dagi `foizMatni` esa 0..1 ULUSH oladi. Birliklar aralashmasin: bu
 * funksiya faqat analitika konvertidagi `rate` uchun.
 */
export function foizMatni100(rate: number | null): string {
	if (rate === null) {
		return BOSH;
	}
	return `${rate.toFixed(1).replace(".", ",")}%`;
}

/** `"2026-09-05"` → `"05"` — ustun o'qi yorlig'i. */
export function kunYorlig(sana: string): string {
	return sana.slice(8, 10);
}

/** `"2026-09-05"` → `"05.09"` — ustun tooltip'i. */
export function sanaQisqa(sana: string): string {
	return `${sana.slice(8, 10)}.${sana.slice(5, 7)}`;
}

/** ISO hafta kuni (1 = dushanba) bo'yicha tartib; SQL tartibiga tayanilmaydi. */
export function tartiblanganHaftaKunlari<T extends { weekday: number }>(qatorlar: T[]): T[] {
	return [...qatorlar].sort((a, b) => a.weekday - b.weekday);
}

/** Layout qatori — mobil kenglikda bitta ustun. */
export function AnalyticsGrid({ cols, children }: { cols: 2 | 3; children: ReactNode }) {
	return (
		<div className={`grid grid-cols-1 gap-4 ${cols === 3 ? "xl:grid-cols-3" : "lg:grid-cols-2"}`}>
			{children}
		</div>
	);
}

/** `byDepartment` qatorining nomi — `NULL` bo'lim tarjima qilingan yorliq oladi. */
export function useBolimNomi(): (nom: string | null) => string {
	const { t } = useTranslation("reports");
	return (nom) => nom ?? t("analytics.attendance.noDepartment");
}
